import browser from '@openclassrooms/utils/browser';

import smileyService from '../../Services/smiley';

const init = () => {
  [...browser.document.querySelectorAll('.js-smilize')].forEach(smileyService.smilize);
};

export default {
  init,
};
